import React, { useState, useEffect } from "react";
import * as S from "./ReportStyled";
import SelectDate from "../filter/SelectDate";
import Dropdown from "../filter/Dropdown";
import API from "../../../utils/Api";
import dateFormat from "dateformat";
import Loader from "../../common/loader";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";
import ResponsiveRow from "./ResponsiveRow";

function SalesPersonWiseLedger() {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState(null);
  const [productData, setProductData] = useState(null);
  const [salesPersonData, setSalesPersonData] = useState(null);
  const [prodIndex, setProdIndex] = useState(0);
  const [salesIndex, setSalesIndex] = useState(0);
  const [total, setTotal] = useState({ stockQuantity: 0, stockBalance: 0 });

  const getData = async (init) => {
    setLoading(true);
    let response = await API.get(`report/SalespersonLedgerReport`, {
      params: {
        startDate: dateFormat(startDate, "yyyy-mm-dd"),
        endDate: dateFormat(endDate, "yyyy-mm-dd"),
        salespersonId: salesPersonData && salesPersonData[salesIndex].id,
        productId: productData && productData[prodIndex].id,
      },
      headers: { Token: localStorage.getItem("token") },
    });
    if (init) {
      let salesResponse = await API.get(`salesperson/SalesPersonAll`, {
        headers: { Token: localStorage.getItem("token") },
      });
      let prodResponse = await API.get(`product/productall`, {
        headers: { Token: localStorage.getItem("token") },
      });
      setSalesPersonData([
        { salespersonName: "All" },
        ...salesResponse.data.data.results,
      ]);
      setProductData([
        { productName: "All" },
        ...prodResponse.data.data.results,
      ]);
    }
    setdata(response.data.data.results);
    setLoading(false);
  };

  useEffect(() => {
    getData(true);
  }, []);

  useEffect(() => {
    getData();
  }, [startDate, endDate, prodIndex, salesIndex]);

  useEffect(() => {
    setTotal({ stockQuantity: 0, stockBalance: 0 });
    if (data) {
      data.forEach((e) => {
        setTotal((a) => ({
          stockQuantity: e.stockQuantity + a.stockQuantity,
          stockBalance: e.stockBalance + a.stockBalance,
        }));
      });
    }
  }, [data]);

  return (
    <S.Wrapper>
      <ResponsiveRow
        items={[
          <SelectDate
            label="Till Date:"
            date={startDate}
            changeDate={(date) => setStartDate(date)}
          />,
          productData && (
            <Dropdown
              label="Choose Product:"
              onSelect={(index) => {
                setProdIndex(index);
              }}
              selectedItem={prodIndex}
              options={productData.map((e, index) => ({
                value: index,
                title: e.productName,
              }))}
            />
          ),
          salesPersonData && (
            <Dropdown
              label="Choose Sales Person:"
              onSelect={(index) => {
                setSalesIndex(index);
              }}
              selectedItem={salesIndex}
              options={salesPersonData.map((e, index) => ({
                value: index,
                title: e.salespersonName,
              }))}
            />
          ),
          <S.Text>Sales-person wise Ledger</S.Text>,
          <ReactHTMLTableToExcel
            id="download-button"
            className="download"
            table="reports"
            filename="reports"
            sheet="report"
            buttonText={
              <span>
                <img
                  width={25}
                  height={25}
                  src="https://img.icons8.com/ios/50/000000/ms-excel.png"
                  alt={"Excel"}
                />{" "}
                Excel
              </span>
            }
          />,
        ]}
        table={
          loading ? (
            <Loader />
          ) : (
            <S.TableWrapper>
              <S.Table id="reports">
                <S.TableRow>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Stock Date
                  </S.TableHeader>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Particulars
                  </S.TableHeader>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Stock Quantity
                  </S.TableHeader>
                  <S.TableHeader style={{ textAlign: "center" }}>
                    Stock Balance
                  </S.TableHeader>
                </S.TableRow>
                <S.TableBody>
                  {data && data.length !== 0 ? (
                    <S.TableRow>
                      <S.TableData>
                        <b>TOTAL</b>
                      </S.TableData>
                      <S.TableData></S.TableData>
                      <S.TableData style={{ textAlign: "right" }}>
                        <b>{total.stockQuantity.toLocaleString("en-IN")}</b>
                      </S.TableData>
                      <S.TableData style={{ textAlign: "right" }}>
                        <b>{total.stockBalance.toLocaleString("en-IN")}</b>
                      </S.TableData>
                    </S.TableRow>
                  ) : null}
                  {data.map((e, index) => (
                    <S.TableRow>
                      <S.TableData>{e.stockDate}</S.TableData>
                      <S.TableData>
                        <span>
                          <img
                            alt={index}
                            src={e.image}
                            height="20"
                            width="20"
                            style={{ marginRight: "6px" }}
                          />
                          {e.particulars}
                        </span>
                      </S.TableData>

                      <S.TableData
                        style={{
                          color: e.stockQuantity < 0 ? "red" : "green",
                          textAlign: "right",
                        }}
                      >
                        {e.stockQuantity.toLocaleString("en-IN")}
                      </S.TableData>
                      <S.TableData style={{ textAlign: "right" }}>
                        ₹ {e.stockBalance.toLocaleString("en-IN")}
                      </S.TableData>
                    </S.TableRow>
                  ))}
                </S.TableBody>
              </S.Table>
            </S.TableWrapper>
          )
        }
      />
    </S.Wrapper>
  );
}

export default SalesPersonWiseLedger;
